import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";

export default function PackageModal({
  open,
  onClose,
  refetch,
  selectedRow = null,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            maxWidth: "unset",
            width: { xs: "95vw", lg: "1100px" },
            bgcolor: "#E5F4FF",
            borderRadius: "20px",
          },
        },
      }}
    >
      <DialogContent>
        {/* Title */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: "20px",
          }}
        >
          <Typography sx={{ color: "rgba(93, 106, 130, 1)", fontSize: 20 }}>
            Add Package
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* form */}
        <Box component="form">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                options={[]}
                getOptionLabel={(option) => option?.countryName || ""}
                renderInput={(params) => (
                  <TextField {...params} label="Code" name="code" fullWidth />
                )}
                sx={{ bgcolor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                options={[]}
                getOptionLabel={(option) => option?.countryName || ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Item Barcode"
                    name="itemBarcode"
                    fullWidth
                  />
                )}
                sx={{ bgcolor: "white" }}
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                options={[]}
                getOptionLabel={(option) => option?.countryName || ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Item Name"
                    name="itemName"
                    fullWidth
                  />
                )}
                sx={{ bgcolor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                options={[]}
                getOptionLabel={(option) => option?.countryName || ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Quantity"
                    name="quantity"
                    fullWidth
                  />
                )}
                sx={{ bgcolor: "white" }}
              />
            </Grid>
          </Grid>
          <Box sx={{ display: "flex", justifyContent: "center", mt: "20px" }}>
            <Button
              variant="contained"
              type="submit"
              sx={{
                textTransform: "none",
                backgroundColor: "rgba(1, 121, 176, 1)",
                width: "150px",
              }}
              // disabled={isLoading}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
